<!--
 * @Descripttion: 
 * @version: 
 * @Author: WDL
 * @Date: 2023-03-17 14:34:59
 * @LastEditors: WDL
 * @LastEditTime: 2023-11-21 10:04:28
-->
<template>
    <base-layout title="任务记录" :hideHeader="true">
        <template slot="main">
            <div class="content taskContent" >  
                <div class="taskRecordBg">
                    <img src="./_img/taskCenter/taskrecordbg.png"/>
                </div>
                <div class="taskRecordContent" v-if="recordList.length>0">
                    <div class="taskRecordList" >
                        <div class="taskRecordHeader">
                            <div class="taskRecordTitle">任务</div>
                            <div class="taskRecordStatus">完成状态</div>
                        </div>
                        <div class="m-item" v-for="(info,index) in recordList" :key="index" :class="index != recordList.length-1 ? 'bd':''">
                            <img :src="info.img" class="m-icon"/>
                            <div class="m-center">
                                <div class="m-title">{{info.taskName}}</div> 
                                <div class="m-contair">{{info.subhead}}</div>
                                <div class="m-topic limit-topic">{{info.subhead2}}</div>
                            </div>
                            <div class="m-button success-button" v-if="info.isComplete">已完成</div>
                            <div class="m-button error-button" v-else>未完成</div>
                        </div>
                    </div>
                

                </div>
                <div v-else class="noTaskRecord">
                    您还没有任何记录，快去完成任务得奖励吧！
                    </div>
            </div>
        </template>
    </base-layout>
</template>

<script>
    import baseLayout from '@comm/view/layout/baseLayout';
    // loading加载
    import loading from '@components/comm/loading'
    // 用户存储
    import userStore from '@comm/store/user/userInfo.store.js'
    import TaskCenter_Methods from '@comm/store/taskcenter.store';
    // 轮播图组件
    import tab from '@components/comm/tab'
    import tabItem from '@components/comm/tabItem'
    import {Toast} from 'vant';
	export default {
		name: 'myMemberTaskRecord',
        components: {
			loading,
			baseLayout,
            tab,
            tabItem
		},
		data() {
			return {
                //限时任务列表
                recordList:[],
                userId: '',
                userPhone:''//手机号
            }
        },
        methods:{
            getData(){
                TaskCenter_Methods('getTaskReceiveRecord',{ userId: this.userId }).then(res=>{
                    //任务类型为优惠券核销任务的特殊处理
                    let infos = res||[];
                    if(infos.length>0){
                        this.getVerifyCouponStatus(infos,0);
                    }
                })
            },
            //获取券核销任务的券使用状态
            async getVerifyCouponStatus(infos,index){ 
                if(index>=infos.length){
                    return false;
                }
                let info=infos[index];
                if(info.taskType=='7'&&info.ruleIds){
                    let ruleIdList = info.ruleIds;
                    let completeValue = info.completeValue||1;
                    let res = await TaskCenter_Methods('getQueryCouponStatus', {
                        phone: this.userPhone,
                        ruleIdList:ruleIdList
                    })
                    let queryCouponInfo = res.data || [];
                    //已使用的券数量
                    let useedCouponNum = (queryCouponInfo.filter((info)=>{return info.couponStatus == 3}) || []).length;
                    if(useedCouponNum>=completeValue){
                        info.isComplete =true;
                    }else{
                        info.isComplete =false;
                    }
                }
                this.recordList.push(info);  
                await this.getVerifyCouponStatus(infos,index+1);   
			},
            //获取用户信息
            getUserInfo(){
                if(!this.isLogin){
                    this.$router.push({path: '/my/member/index'});
                };
                // 获取用户信息（此段代码替换通用方法）
                userStore.dispatch('updateUserDetail', { pageFlag: 'taskRecord' }).then(res => {
                    this.userId = res.id;
                    this.userPhone=res.cellPhone;
                    //不是会员则跳转到会员中心
                    if(res.isLoyalty!==1){
                        this.$router.push({path: '/my/member/index'});
                    }else{
                        this.getData();
                    }
                }, err => {
                    Toast(err);
                    this.$router.push({path: '/my/member/index'});
                })
            },
        },  
        mounted(){
            this.getUserInfo();
        },
        computed: {
              // 是否登录
            isLogin() {
                return userStore.getters.isLogin;
            },
		}
	}
</script>

<style lang="scss" scoped>
    .content{
        background: #F8F8F8;
        min-height: fill-available;
    }
    .taskContent{
        overflow-y: scroll;
        height: 100%;
    }
    .taskRecordBg{
        width: 100%;
        img{
            display: block;
            width: 100%;
            height: 100%;
        }
    }
    .taskRecordContent{
        width: 92%;
        min-height: 150px;
        background: #FFFFFF;
        border-radius: 18px;
        margin: 0 auto;
        margin-top: -30px;
        .taskRecordList{
            padding:28px 28px 0 28px;
            margin-bottom: 40px;
            .taskRecordHeader{
                display: flex;
                font-size: 17px;
                font-family: "Source Han Sans SC";
                font-weight: 700;
                color: #006AA6;
                .taskRecordTitle{
                    flex: 1;
                    font-size: 17px;
                }
                .taskRecordStatus{
                    font-size: 17px;
                }
            }
            .m-item{
                display: flex;
                margin-top: 15px;
                padding-left:2px;
                padding-bottom: 12px;
                .m-center{
                    width: 200px;
                }
                .m-icon{
                    width: 30px;
                    height: 23px;
                    margin-top: 5px;
                }
                .m-button{
                    width: 61px;
                    height: 28px;
                    font-size: 12px;
                    line-height: 28px;
                    border-radius: 20px;
                    text-align: center;
                    margin-right: 6px;
                }
                .m-center{
                    width: 200px;
                    margin-left: 10px;
                    // line-height: 26px;
                }
                .m-title{
                    font-weight: 700;
                    font-size: 14px;
                }
                .m-contair{
                    color: #858585;
                    font-size: 12px;
                    line-height: 17px;
                    // line-height: 19px;
                }
                .m-topic{
                    font-size: 12px;
                    color: #006AA6;
                }
                .success-button{
                    font-size: 14px;
                    font-weight: 700;
                    color: #CD092F;
                }
                .error-button{
                    font-size: 14px;
                    font-weight: 700;
                    color: #2F2F2F;
                }
            }
            .bd{
                border-bottom: 1px solid #ebebeb;
            }
        }
      
    }
    .noTaskRecord{
            color: #858585;
            text-align: center;
            padding-top: 16px;
            font-size: 14px;
            text-align: center;
            width: 100%;
        }
</style>